import { View } from '@react-pdf/renderer';

import { GraphImage } from '../../../../../components/pdf';

export default function PdfDowVolume({ graphUri }: { graphUri: string }) {
  return (
    <View>
      <GraphImage src={graphUri} />
    </View>
  );
}
